import axios from "axios"
import { fetchWrapper } from "@/helpers"

const localApiUrl = process.env.VUE_APP_PROXY_SERVER + "/api/User"

class UserApi {
  async authenticate(username, password) {

    try {
      var url = localApiUrl + "/Authenticate"

      const response = await axios.post(url,
        {
          username: username,
          password: password,
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      )

      return response.data

    } catch (error) {
      return error
    }
  }

  async find(id) {
    return fetchWrapper.get(`${localApiUrl}/Find?user_id=${id}`)
  }

  async searchUser(filter) {
    return fetchWrapper.post(`${localApiUrl}/SearchUser`, filter)
  }

  async createUser(user) {
    return fetchWrapper.post(`${localApiUrl}/Create`, user)
  }

  async updateUser(user) {
    return fetchWrapper.put(`${localApiUrl}/Update`, user)
  }

  async deleteUser(id) {
    const url = `/Delete?user_id=${id}`

    return fetchWrapper.delete(`${localApiUrl}${url}`)
  }

  async getRole(id) {
    return fetchWrapper.get(`${localApiUrl}/Role?id=${id}`)
  }

  async createRole(role) {
    return fetchWrapper.post(`${localApiUrl}/CreateRole`, role)
  }

  async updateRole(role) {
    return fetchWrapper.put(`${localApiUrl}/UpdateRole`, role)
  }

  async deleteRole(id) {
    const url = `/DeleteRole?id=${id}`

    return fetchWrapper.delete(`${localApiUrl}${url}`)
  }

  async searchUserGroup(req) {
    return fetchWrapper.post(`${localApiUrl}/SearchUserGroup`, req)
  }

  async getListUserGroup() {
    return fetchWrapper.get(`${localApiUrl}/UserGroupList`)
  }

  async getUserGroup(id) {
    return fetchWrapper.get(`${localApiUrl}/UserGroup?id=${id}`)
  }

  async createUserGroup(userGroup) {
    return fetchWrapper.post(`${localApiUrl}/CreateUserGroup`, userGroup)
  }

  async updateUserGroup(userGroup) {
    return fetchWrapper.post(`${localApiUrl}/UpdateUserGroup`, userGroup)
  }

  async deleteUserGroup(id) {
    const url = `/DeleteUserGroup?id=${id}`

    return fetchWrapper.delete(`${localApiUrl}${url}`)
  }

  async sendResetEmail(username) {
    try {
      var url = `${localApiUrl}/sendResetEmail?userName=${username}`

      return await axios
        .post(url)
        .then(response => { return response })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data)
            console.log(error.response.status)

            return error.response
          }
        })
    } catch (ex) {
      console.log(ex)

      return null
    }
  }

  async resetPassword(req) {
    return fetchWrapper.put(`${localApiUrl}/ResetPassword`, req)
  }

  // Change apssword by user have permission reset password
  async resetPasswordByAdmin(id) {
    var url = `${localApiUrl}/ChangePasswordByAdmin?id=${id}`

    return await fetchWrapper.post(url)
  }

  async changePassword(data, token) {
    try {
      var url = `${localApiUrl}/changePassword`
      return await axios
        .put(url, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          return response
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data)
            console.log(error.response.status)

            return error.response
          }
        })
    } catch (ex) {
      console.log(ex)

      return null
    }
  }
}

export default UserApi